export * from './FileTypePictureIcon';
export * from './FileTypePictureIcon16Light';
export * from './FileTypePictureIcon16Regular';
export * from './FileTypePictureIcon16Solid';
export * from './FileTypePictureIcon20Light';
export * from './FileTypePictureIcon20Regular';
export * from './FileTypePictureIcon20Solid';
export * from './FileTypePictureIcon24Regular';
export * from './FileTypePictureIcon24Solid';
export * from './FileTypePictureIcon32Regular';
export * from './FileTypePictureIcon64Regular';
